import { transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@transient()
export class GhgVerificationAssignmentDialog {
    model: any;

    constructor(private dialogClientService: DialogClientService) { }

    activate(model: any) {
        this.model = model;
    }

    cancel() {

        if (this.model.onCancel) {
            this.model.onCancel();
        }

        this.dialogClientService.hide();
    }

    submit() {
        return new Promise<void>((resolve, reject) => {
            if (this.model && this.model.submit) {
                this.model.submit().then(() => {
                    this.model.isSubmitting = true;

                    this.dialogClientService.hide().then(() => {
                        if (this.model.callback) {
                            setTimeout(() => {
                                const res = this.model.callback();
                                if (res instanceof Promise) {
                                    res.then(() => {
                                        this.model.isSubmitting = false;
                                        resolve();
                                    }).catch(e => {
                                        this.model.isSubmitting = false;
                                        reject(e);
                                    });
                                } else {
                                    this.model.isSubmitting = false;
                                    resolve();
                                }
                            });
                        }
                        else {
                            this.model.isSubmitting = false;
                            resolve();
                        }
                    });
                }, reject);
            }
            else {
                resolve();
                this.cancel();
            }
        });
    }
}
